/**
 * 処分場受入
 * 最終処分完了報告(最資源化対応)
 */
import Vue from 'vue'
import * as httpConst from '../../../../constants/httpConst'

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/orders/recycle_final_disposal_reports`

const order_recycle_final_disposal_report = {
  namespaced: true,
  state: {},
  getters: {},
  actions: {
    /**
     * 最終処分完了報告初期情報
     * @param commit
     * @param params
     * @return {Promise<unknown>}
     */
    show ({ commit }, { params }) {
      return new Promise((resolve, reject) => {
        Vue.$http.post(`${API_PATH}/report_items`, params).then(data => {
          resolve(data.content)
        }).catch(error => {
          reject(error)
        })
      })
    },
    new () {
      return new Promise((resolve, reject) => {
        Vue.$http.get(`${API_PATH}/new`).then(data => {
          resolve(data.content)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /**
     * 最終処分終了報告 一括登録
     * @param param0
     * @param param0.commit
     * @param param1
     * @param param1.params
     * @return {Promise<unknown>}
     */
    create ({ commit }, { params }) {
      return new Promise( ( resolve ) => {
        Vue.$http.post(API_PATH, params).then( data => {
          let content = data.content
          commit('snackbar/showInfo', { message: '登録しました' }, { root: true })
          resolve(content)
        } )
      })
    },

    /**
     * 最終処分終了報告 個別登録
     * @param commit
     * @param params
     * @return {Promise<unknown>}
     */
    update ({ commit }, { params }) {
      return new Promise( ( resolve ) => {
        Vue.$http.put(API_PATH, params).then( data => {
          let content = data.content
          commit('snackbar/showInfo', { message: '登録しました' }, { root: true })
          resolve(content)
        } )
      })
    },
  },
  mutations: {},
}

export default order_recycle_final_disposal_report
